import { setCookie as setNextCookie, getCookie as getNextCookie, deleteCookie as deleteNextCookie } from 'cookies-next';

// Two months in seconds (60 seconds * 60 minutes * 24 hours * 60 days)
export const TWO_MONTHS_IN_SECONDS = 60 * 60 * 24 * 60;

export const setCookie = (key: string, value: string) => {
  setNextCookie(key, value, {
    maxAge: TWO_MONTHS_IN_SECONDS,
    path: '/',
  });
};

export const getCookie = (key: string) => {
  return getNextCookie(key);
};

export const deleteCookie = (key: string) => {
  deleteNextCookie(key, { path: '/' });
}; 